<template>
  <div class="specials__special-boxes">
    <SpecialBox
      v-for="special in specials"
      :key="special.id"
      :special-id="special.id"
      :special-title="special.title"
      :started-at="special.startedAt"
      :image-url="special.imageUrl"
    />
  </div>
</template>
<script>
import SpecialBox from './SpecialBox.vue'
export default {
  components: { SpecialBox },
  props: {
    specials: {
      type: Array,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.specials {
  &__special-boxes {
    max-width: $sp-width;
    margin: auto;
    padding: 0 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
